/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stage_Client_In_NegotiationInputs */

const en_stage_client_in_negotiation = /** @type {(inputs: Stage_Client_In_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contract Negotiation`)
};

const pt_br2_stage_client_in_negotiation = /** @type {(inputs: Stage_Client_In_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negociação de Contrato`)
};

/**
* | output |
* | --- |
* | "Contract Negotiation" |
*
* @param {Stage_Client_In_NegotiationInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const stage_client_in_negotiation = /** @type {((inputs?: Stage_Client_In_NegotiationInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stage_Client_In_NegotiationInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_stage_client_in_negotiation(inputs)
	return pt_br2_stage_client_in_negotiation(inputs)
});